/**
 * 新增 编辑
 * @author 3173
 * @description  新增/编辑
 * @Date  2020/9/28
 */
import React, { Component } from 'react';
import { Form } from 'antd'
import { component_tool, framework_tool } from '@/tool'
import { WizTableForm, WizClassifySelectRe, WizAuthority, WizDataAuthSelect, WizBraftEditorPlus } from '../../../common'
import moment from "moment";

let { WizAvatarUpload, ossFileUtils, WizFileUpload, WizOssUpload } = framework_tool

let {
  WizButton,
  WizSelect,
  WizTooltip,
  WizInput,
  WizIcon,
  WizUpload,
  WizDatePicker,
  WizRow,
  WizCol,
  WizCard,
  WizRadio,
  WizDivider,
  WizCheckbox,
  WizInputNumber,
  Wizmessage,
  WizAlert,
  WizTreeSelect
} = component_tool;
let WizForm = Form
let Item = Form.Item
let Option = WizSelect.Option

/**
 * 此组件没有继承WizComponent，因为需要使用Form.create()该组件
 * 继承WizComponent后 form的部分功能缺失了
 * 初步怀疑是WizComponent修改了生命周期的钩子导致的
 * by mll 2020-2-4
 */

class HomeworkForm extends Component {

  constructor(props) {
    super(props);
    let { initialValue } = props;
    this.state = {
      type: initialValue && initialValue.liveType ? initialValue.liveType : 1,
      wizAuthorityKey: 'wizAuthorityKey' //用于处理wizAuthority组件重置不生效问题
    }
    this.initialValue = props.initialValue ? props.initialValue : {},
      this.clearWizCallBack = [];
  }


  /**上传校验 */
  _ossBeforeUpload(file, fileList, _onRemove) {
    let result = true;
    if (file.type.indexOf('application/') == -1) {
      let name = file.name.split(".")[0];
      if (name.length > 20) {
        result = false;
        //_onRemove();
        Wizmessage.error('上传文件名称不可超过20个字,请确认后重试！');
      }
    }
    return result;
  }

  /** 上传的文件显示内容 */
  _fileChildren() {
    let icon = <WizIcon type="loading" style={{ fontSize: 14 }} />
    let fileName = ''
    if (this.state.file && this.state.file.fileOriginalName) {
      icon = <WizIcon type="paper-clip" />;
      fileName = this.state.file.fileOriginalName;
    } else if (this.state.file && this.state.file.name) {
      fileName = this.state.file.name;
    }
    //anticon anticon-loading
    return (
      <>
        <WizButton><WizIcon type="upload" /> 选择文件</WizButton>
        {
          this.state.file ?
            <div class=" ant-upload-list ant-upload-list-text">
              <div class="ant-upload-list-item ant-upload-list-item-done ant-upload-list-item-list-type-text">
                <div class="ant-upload-list-item-info">
                  {icon}
                  <span class="ant-upload-list-item-name ant-upload-list-item-name-icon-count-2"> {fileName} </span>
                </div>
              </div>
              {/* <WizProgress strokeColor={{ '0%': '#108ee9', '100%': '#87d068', }} status="active" percent={99.9} showInfo={false}/> */}
            </div> : <></>
        }
      </>
    )
  }

  /** ?提示 */
  _renderCheckTips(tips) {
    if (tips) {
      return (
        <WizTooltip title={tips} >
          <WizIcon type='question-circle-o' />
        </WizTooltip>
      )
    }
  }

  /**
   * 表单基础内容
   *  Item hasFeedback 展示校验状态图标
   */
  _base() {
    const { getFieldDecorator, getFieldValue, setFieldsValue } = this.props.form;

    let typeListVal = getFieldValue('typeList') // 选中的形式类型

    const defaultImgList = (fileList, fileIds) => {
      let imgs = []
      let imgList = []
      if (fileIds && !$$.isArray(fileIds)) {
        fileList && fileList.forEach(img => {
          if (fileIds && fileIds === img.file_id) {
            imgList.push(img)
          }
        })
      }

      if (imgList && imgList.length && imgList.length > 0) {
        fileList = imgList
      }

      fileList && fileList.length && fileList.forEach(img => {
        imgs.push({
          ...ossFileUtils.getOssFile(
            img.fileId,
            img.fileName,
            img.fileMimeType,
            img.fileSize,
            img.fileUri,
          ), uid: img.fileId
        })
      })
      return imgs
    }

    const TmpCheckbox = ({ value, onChange }) => {
      const _onChange = (e) => {
        let callback = (call) => call && call()
        if (e.target?.checked) {
          callback = (call) => setFieldsValue({ endDate: moment('2099-12-31 23:59:59') }, call)
        }
        callback(() => onChange && onChange(e))
      }
      return <WizCheckbox checked={value} onChange={_onChange}>长期</WizCheckbox>
    }


    let typesMenu = [
      {name:'文字',value:0},
      {name:'图片',value:1},
      {name:'视频',value:2},
      {name:'音频',value:3},
      {name:'文件',value:4},
    ]

    let items = [
      <Item label="标题">
        {getFieldDecorator('name', {
          rules: [{ required: true, message: '请输入标题' }],
          initialValue: this.initialValue.name,
        })(<WizInput maxlength={30} placeholder='请输入标题,最多输入30个字' disabled={this.initialValue.homeworkRecordCount ? (this.initialValue.homeworkRecordCount == 0 ? false : true) : false} />)}
      </Item>,
      <Item label="要求">
        {getFieldDecorator('requirement', {
          rules: [{ required: true, message: '请输入作业要求' }],
          initialValue: this.initialValue.requirement,
        })(<WizBraftEditorPlus links={[0, 1, 2, 3]} disabled={this.initialValue.homeworkRecordCount ? (this.initialValue.homeworkRecordCount == 0 ? false : true) : false} />)}
      </Item>,

      <Item label="图片附件上传">
        {getFieldDecorator('imgList', {
          // initialValue: this.initialValue.imgList ? this.initialValue.imgList : []
          initialValue: this.initialValue.imgMimes ? defaultImgList(this.initialValue.imgMimes) : [],
        })(
          <WizOssUpload key={'img01'}
            multiple
            accept={'.jpg, .jpeg, .png'}
            listType={'picture'}
            beforeUpload={this._ossBeforeUpload.bind(this)}
            protect={false}
            uploadType={'homework'}//⭐️表示临时储存空间，正式业务请根据场景自行传入
            disabled={this.initialValue.state ? true : false}
          />
        )
        }
      </Item>,

      <Item label="视频附件上传">
        {getFieldDecorator('videoList', {
          initialValue: this.initialValue.videoMimes ? defaultImgList(this.initialValue.videoMimes) : []
        })(
          <WizOssUpload key={"video01"}
            multiple
            accept={'.mp4,.mov,.avi,.rm,.mpg'}
            listType={'picture'}
            beforeUpload={this._ossBeforeUpload.bind(this)}
            protect={false}
            uploadType={'homework'}//⭐️表示临时储存空间，正式业务请根据场景自行传入
            disabled={this.initialValue.state ? true : false}
          />
        )
        }
      </Item>,

      <Item label="音频附件上传">
        {getFieldDecorator('audioList', {
          initialValue: this.initialValue.audioMimes ? defaultImgList(this.initialValue.audioMimes) : []
        })(
          <WizOssUpload key={'audio02'}
            multiple
            accept={'.mp3,.wav'}
            listType={'picture'}
            beforeUpload={this._ossBeforeUpload.bind(this)}
            protect={false}
            uploadType={'homework'}//⭐️表示临时储存空间，正式业务请根据场景自行传入
            disabled={this.initialValue.state ? true : false}
          />
        )
        }
      </Item>,

      <Item label="文件附件上传">
        {getFieldDecorator('fileList', {
          initialValue: this.initialValue.fileMimes ? defaultImgList(this.initialValue.fileMimes) : []
        })(
          <WizOssUpload key={"file03"}
            multiple
            accept={'.doc,.docx,.xls,.xlsx,.ppt,.pptx,.pdf'}
            listType={'picture'}
            beforeUpload={this._ossBeforeUpload.bind(this)}
            protect={false}
            uploadType={'homework'}//⭐️表示临时储存空间，正式业务请根据场景自行传入
            disabled={this.initialValue.state ? true : false}
          />
        )
        }
      </Item>,




      <Item label="形式" required>
        {getFieldDecorator('typeList', {
          initialValue: this.initialValue.typeList ? this.initialValue.typeList : [],
          rules: [{ required: true, message: '请输入形式' }],
        })(
          <WizCheckbox.Group
            onChange={(e) => {
              this.setState({ type: e })
              // 切换时判断一下必填区是否选中 如果当前项被移除,必选内容区也要删除
              let requiredTypes = getFieldValue('requiredTypeList') || []
              if (e.length && requiredTypes.length) {
                let filteVal = requiredTypes.filter(row => e.includes(row))
                setFieldsValue({ 'requiredTypeList': filteVal })
              } else if (e.length === 0 && requiredTypes.length) {
                setFieldsValue({ 'requiredTypeList': [] })
              }
            }}
            disabled={this.initialValue.homeworkRecordCount ? (this.initialValue.homeworkRecordCount == 0 ? false : true) : false} >
            <WizCheckbox value={0}>文字</WizCheckbox>
            <WizCheckbox value={1}>图片</WizCheckbox>
            <WizCheckbox value={2}>视频</WizCheckbox>
            <WizCheckbox value={3}>音频</WizCheckbox>
            <WizCheckbox value={4}>文件</WizCheckbox>
          </WizCheckbox.Group>,
        )}
      </Item>,
      <Item label="是否必填">
        {getFieldDecorator('requiredTypeList', {
          initialValue: this.initialValue.requiredTypeList ? this.initialValue.requiredTypeList : [],
        })(
          <WizCheckbox.Group
            disabled={this.initialValue.homeworkRecordCount ? (this.initialValue.homeworkRecordCount == 0 ? false : true) : false}
          >
            {
              typesMenu.map(i => {
                return (
                  <WizCheckbox disabled={!typeListVal?.includes(i.value)} key={i.value} value={i.value}>{i.name}</WizCheckbox>
                )
              })
            }
          </WizCheckbox.Group>
        )}
      </Item>,

      <Item label="作业分类" >
        {getFieldDecorator('categoryId', {
          rules: [{ type: 'array' }, { required: true, message: '请选择作业分类' }],
          initialValue: this.initialValue.categoryId ? [this.initialValue.categoryId] : [],
        })(
          <WizClassifySelectRe
            returnKey={true}
            apiProps={{ type: 11, state: 1 }}
            initSelects={this.initialValue.categoryInfo ? this.initialValue.categoryInfo : []}
            wizTreeSelectListProps={{
              itemProps: {
                icon: 'unordered-list',
                title: '作业分类',
                tips: '请勾选作业分类'
              },
              multiple: false,
              treeCheckable: false,
              checkable: false,
              showSelectList: true,
              treeProps: { checkStrictly: true }
            }}
            onClearWiz={this._onClearWiz.bind(this)}

          />
          // <WizTreeSelect/>
        )}
      </Item>,
      <Item label="开始时间">
        {getFieldDecorator('startDate', {
          rules: [{ required: true, message: '请选择开始时间', }],
          initialValue: this.initialValue.startDate
        })(<WizDatePicker key='startDate' showTime placeholder="请选择开始时间" disabled={this.initialValue.state === 3 ? true : false} />)}
      </Item>,
      <Item label="结束时间">
        {/*{getFieldDecorator('endDate', {*/}
        {/*  rules: [{ required: true, message: '请选择结束时间', }],*/}
        {/*  initialValue: this.initialValue.endDate*/}
        {/*})(<WizDatePicker key='endDate' showTime placeholder="请选择结束时间" />)}*/}
        {
          [
            getFieldDecorator('endDate', {
              initialValue: this.initialValue.endDate,
              rules: [{ required: true, message: '请选择结束时间', }]
            })(<WizDatePicker placeholder={'请选择结束时间'} disabled={getFieldValue('longer') || false} showTime />),
            <div />,
            getFieldDecorator('longer', {
              initialValue: getFieldValue('endDate') >= moment('2099-12-31 00:00:00') || false,
            })(<TmpCheckbox />)
          ]
        }
      </Item>,

      <Item label="是否公开展示" required>
        {getFieldDecorator('open', {
          initialValue: this.initialValue.open || this.initialValue.open === 0 ? this.initialValue.open : 1
        })(
          <WizRadio.Group>
            <WizRadio value={1}>是</WizRadio>
            <WizRadio value={0}>否</WizRadio>
          </WizRadio.Group>
        )}
      </Item>,
      <Item label="是否允许重复提交" required>
        {getFieldDecorator('resubmit', {
          initialValue: this.initialValue.resubmit || this.initialValue.resubmit === 0 ? this.initialValue.resubmit : 1
        })(
          <WizRadio.Group>
            <WizRadio value={1}>是</WizRadio>
            <WizRadio value={0}>否</WizRadio>
          </WizRadio.Group>
        )}
      </Item>,
      getFieldValue('resubmit') === 1 ?
        <Item label="允许重复提交次数">
          {
            getFieldDecorator('resubmitLimit', {
              initialValue: [null, undefined].indexOf(this.initialValue.resubmitLimit) === -1 ? this.initialValue.resubmitLimit : 0
            })(<WizInputNumber min={0} max={9999}/>)
          }
          <span style={{display: 'inline-block',width: 5}}/>
          <WizTooltip title={'允许重复提交次数默认0无限制'}>
            <WizIcon type='question-circle-o' />
          </WizTooltip>
        </Item> : null,
      <Item label="受众" >
        {getFieldDecorator('authCmd', {
          initialValue: Object.assign({}, this.initialValue.authInfo),
          rules: [{ required: true, message: '请选择受众' }],
        })(<WizDataAuthSelect />)}
      </Item>,
      <Item label="是否需要批阅" required>
        {getFieldDecorator('reviewType', {
          initialValue: this.initialValue.reviewType ? this.initialValue.reviewType : 0
        })(
          <WizRadio.Group>
            <WizRadio value={0}>人工</WizRadio>
            {/* <WizRadio value={1}>智能</WizRadio> */}
            <WizRadio value={2}>无需批阅</WizRadio>
          </WizRadio.Group>
        )}
      </Item>,

    ]
    return items
  }

  /**作业的数据 */
  _homeworkCast() {
    const { getFieldDecorator } = this.props.form;
    const userConfig = WizTableForm.Config.user(this, { apiParams: { state: 1, roleConfig: "reviewHomeworkRoles" } })
    let items = [
      <Item label="评分人" required >
        {getFieldDecorator('reviewerList', {
          rules: [{ required: true, message: '请选择评分人', }],
          initialValue: this.initialValue.reviewerList,
        })(<WizTableForm {...userConfig} selectType={"checkbox"} onClearWiz={this._onClearWiz.bind(this)}
          initRows={this.initialValue.reviewerMap ? this.initialValue.reviewerMap : []} />)}
      </Item>,

      <Item label="满分" >
        {getFieldDecorator('totalScore', {
          initialValue: this.initialValue.totalScore
        })(
          // <WizInput maxLength={50} placeholder={'请输入满分'} />
          <WizInputNumber min={0} max={9999} />
        )}
      </Item>,
      <Item label="及格分" >
        {getFieldDecorator('passScore', {
          initialValue: this.initialValue.passScore
        })(
          //<WizInput maxLength={50} placeholder={'请输入及格分'} />
          <WizInputNumber min={0} max={9999} />
        )}
      </Item>
      // <Item label="状态" required >
      //   {getFieldDecorator('state', {
      //     initialValue: this.initialValue.state ? this.initialValue.state : 0
      //   })(
      //     <WizRadio.Group disabled={this.initialValue.state} >
      //       <WizRadio value={0}>草稿</WizRadio>
      //       <WizRadio value={1}>发布</WizRadio>
      //     </WizRadio.Group>
      //   )}
      // </Item>
    ];
    if (!this.initialValue.state) {
      items.push(
        <Item label="状态" required >
          {getFieldDecorator('state', {
            initialValue: 0
          })(
            <WizRadio.Group>
              <WizRadio value={0}>草稿</WizRadio>
              <WizRadio value={1}>发布</WizRadio>
            </WizRadio.Group>
          )}
        </Item>
      );
    }
    return items
  }


  /**
   * 表单提交按钮
   */
  _submit() {
    return (
      <Item wrapperCol={{ span: 12, offset: 6 }}>
        <WizRow>
          <WizCol span={24} style={{ textAlign: 'center' }}>
            <WizButton style={{ marginLeft: 20 }} title="保存" type="primary" htmlType="submit">保存</WizButton>
            <WizButton style={{ marginLeft: 20 }} onClick={this.handleReset}>重置</WizButton>
          </WizCol>
        </WizRow>
      </Item>
    )
  }

  /**
   * 处理表单提交事件
   */
  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        if (this.props.onSubmit) {
          this.props.onSubmit(values);
        }
      }
    });
  };

  /**
   * 重置表单
   */
  handleReset = () => {
    this.props.form.resetFields();
    this.clearWizCallBack.forEach(callback => {
      callback && callback()
    })
    let type = this.initialValue && this.initialValue.type ? this.initialValue.type : undefined;
    this.setState({
      type: type,
      wizAuthorityKey: 'wizAuthorityKey' + new Date().getTime()
    })
  };

  _onClearWiz(callback) {
    if (callback) {
      this.clearWizCallBack.push(callback)
    }
  }


  render() {
    const { getFieldDecorator } = this.props.form;
    const { title } = this.props;
    const formItemLayout = {
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
    };

    return (
      <WizCard title={title} icon='0'>
        <WizForm
          //key={this.props.formKey}
          {...formItemLayout}
          onSubmit={this.handleSubmit}
        >
          {this._base()}
          {this._homeworkCast()}
          {this._submit()}
        </WizForm>
      </WizCard>
    )

  }
}

export default WizForm.create()(HomeworkForm);


